export default __webpack_public_path__ + "media/images/mailer-new/heading/2fa-enabled-da081fb7fa4306f82c3a1d0397268151.png";